module.exports = __webpack_public_path__ + "static/media/closeX.d1844702.svg";